import type {
  RitualCategoriaInfo,
  SuenyoCategoriaInfo,
} from "@/lib/types/content";

export const RITUAL_CATEGORIAS: RitualCategoriaInfo[] = [
  {
    slug: "amor",
    name: "Amor",
    description:
      "Rituales para atraer amor, recuperar pareja y fortalecer relaciones",
    emoji: "💕",
    color: "from-rose-500 to-pink-600",
  },
  {
    slug: "dinero",
    name: "Dinero y Prosperidad",
    description:
      "Hechizos para atraer abundancia, trabajo y éxito económico",
    emoji: "💰",
    color: "from-emerald-500 to-green-600",
  },
  {
    slug: "trabajo",
    name: "Trabajo y Empleo",
    description:
      "Rituales para conseguir empleo rápido y prosperar profesionalmente",
    emoji: "💼",
    color: "from-amber-500 to-yellow-600",
  },
  {
    slug: "proteccion",
    name: "Protección",
    description:
      "Amuletos y rituales para protegerte de energías negativas",
    emoji: "🛡️",
    color: "from-slate-500 to-stone-700",
  },
  {
    slug: "suerte",
    name: "Buena Suerte",
    description:
      "Hechizos para atraer la fortuna y la suerte en cada área de tu vida",
    emoji: "🍀",
    color: "from-lime-500 to-emerald-500",
  },
  {
    slug: "limpieza",
    name: "Limpieza Energética",
    description:
      "Rituales para limpiar tu casa, cuerpo y espíritu de malas vibras",
    emoji: "✨",
    color: "from-sky-400 to-indigo-500",
  },
  {
    slug: "desamarre",
    name: "Desamarre",
    description:
      "Rituales para alejar personas tóxicas y romper ataduras energéticas",
    emoji: "🪢",
    color: "from-zinc-500 to-neutral-700",
  },
  {
    slug: "salud",
    name: "Salud y Sanación",
    description:
      "Rituales para recuperar la salud, reforzar la energía vital y acompañar tratamientos",
    emoji: "🌿",
    color: "from-emerald-500 to-teal-600",
  },
  {
    slug: "tarot",
    name: "Tarot y Adivinación",
    description:
      "Rituales para consagrar tu baraja, abrir la intuición y prepararte para una lectura",
    emoji: "🔮",
    color: "from-indigo-500 to-violet-600",
  },
];

export const SUENO_CATEGORIAS: SuenyoCategoriaInfo[] = [
  {
    slug: "animales",
    name: "Animales",
    description: "Sueños con animales y su simbolismo espiritual.",
    emoji: "🐍",
  },
  {
    slug: "elementos",
    name: "Elementos",
    description: "Agua, fuego, tierra y aire en el lenguaje onírico.",
    emoji: "🔥",
  },
  {
    slug: "situaciones",
    name: "Situaciones",
    description: "Escenas de la vida que aparecen mientras duermes.",
    emoji: "🌙",
  },
  {
    slug: "personas",
    name: "Personas",
    description: "Familiares, parejas y desconocidos en tus sueños.",
    emoji: "👥",
  },
  {
    slug: "objetos",
    name: "Objetos",
    description: "Lo que cargan y significan los objetos soñados.",
    emoji: "🔑",
  },
];
